import React from "react";
import {
  FiFacebook,
  FiTwitter,
  FiInstagram,
  FiYoutube,
} from "react-icons/all";
import { useLocation } from "react-router-dom";

import logoImg from "../../assets/images/saudedotrabalhador009.svg";
import { FooterLink } from "./FooterLink";
import {
  FooterContainer,
  FooterLinksContainer,
  FooterLinksWrapper,
  SocialMedia,
  ProjectLogo,
  SocialIcons,
  SocialIconLink,
  FooterLinkItems,
  WebSiteRights,
  WebSiteRightsText,
} from "./styles";

function Footer() {


  const location = useLocation();
  const { pathname } = location;
  const splitLocation = pathname.split("/");


  
  return (
    <FooterContainer>
      {splitLocation[1] === 'declaracao-de-privacidade' ? 
      <></> 
      : 
      <>
      <FooterLinksContainer>
        <FooterLinksWrapper>
          <SocialMedia>
            <ProjectLogo src={logoImg} />
            <SocialIcons>
              <SocialIconLink
                target="_blank"
                aria-label="Facebook"
                href="https://www.facebook.com/saudedotrabalhadorcovid19"
              >
                <FiFacebook disabled size={15} color={"#90cbf0"} />
              </SocialIconLink>
              <SocialIconLink
                target="_blank"
                aria-label="Twitter"
                href="https://twitter.com/saudetrab_covid?t=MqFGKG7g7fxCCdDN3lWJrw&s=09"
              >
                <FiTwitter disabled size={15} color={"#90cbf0"} />
              </SocialIconLink>
              <SocialIconLink
                target="_blank"
                aria-label="Instagram"
                href="https://instagram.com/saudedotrabalhador_covid19?utm_medium=copy_link"
              >
                <FiInstagram disabled size={15} color={"#90cbf0"} />
              </SocialIconLink>
              <SocialIconLink
                target="_blank"
                aria-label="Youtube"
                href="https://youtube.com/channel/UCIHUh-oGXjrKOj2TNQc5f5Q"
              >
                <FiYoutube disabled size={15} color={"#90cbf0"} />
              </SocialIconLink>
            </SocialIcons>
          </SocialMedia>
          <FooterLinkItems>
            <FooterLink rota={{ pathname: "/" }}>Início</FooterLink>
            <FooterLink rota={{ pathname: "/paineis" }}>Paineis</FooterLink>
            <FooterLink rota={{ pathname: "/noticias" }}>Notícias</FooterLink>
            <FooterLink rota={{ pathname: "/pesquisas" }}>Pesquisas</FooterLink>
          </FooterLinkItems>
        </FooterLinksWrapper>
      </FooterLinksContainer></>}
      
      <WebSiteRights>
        <WebSiteRightsText>
          © 2022 {splitLocation[1] !== 'declaracao-de-privacidade' ? ', Saúde do trabalhador e a covid-19 ' : ''}– Todos os direitos
          reservados à UFPB
        </WebSiteRightsText>
      </WebSiteRights>
    </FooterContainer>
  );
}

export default Footer;
